<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 生产管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>关联替换查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px" @keyup.enter.native="search()">
          <el-row>
            <el-col :span="6">
              <el-form-item label="订单" prop="orderno">
                <el-input v-model="searchform.orderno" style="width:100%" clearable placeholder="请输入订单" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="批次号" prop="batchno">
                <el-input v-model="searchform.batchno" style="width:100%" clearable placeholder="请输入批次号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="旧码" prop="qrcode">
                <el-input v-model="searchform.qrcode" style="width:100%" clearable placeholder="请输入旧码" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="替换时间" prop="datelist">
                <el-date-picker style="width:100%" v-model="searchform.datelist" type="daterange"
                  value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期"
                  end-placeholder="结束日期"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="margin-left:10px">
              <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search"
                v-permission="['replace_select']">搜索</el-button>
              <el-button v-permission="['replace_export']" :loading="downloadLoading" type="primary" icon="document"
                @click="handleDownload">导出Excel</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>关联替换查询</h4>
          <el-divider></el-divider>
          <el-table border v-loading="listLoading" element-loading-text="拼命加载中" :data="tableData" style="width:100%;"
            id="parent">
            <el-table-column prop="id" label="编号" min-width="65" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode_old" label="旧码" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode_new" label="新码" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode_level" label="包装级别" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode_parent" label="父级码" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="package_level_parent" label="父级包装级别" min-width="120"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="orderno" label="订单" min-width="90" show-overflow-tooltip></el-table-column>
            <el-table-column prop="batchno" label="生产批次" min-width="90" show-overflow-tooltip></el-table-column>
            <el-table-column prop="period_date" label="保质期" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="collection_time" label="采集时间" min-width="130"
              show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="关联替换时间" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_user" label="备注" min-width="80" show-overflow-tooltip></el-table-column>
            <!-- <el-table-column prop="j" label="操作人"></el-table-column> -->
          </el-table>
          <br />
          <el-pagination background @current-change="currentchange" @size-change="pagesize"
            :current-page.sync="currentPage" :page-sizes="[10, 20, 50, 100]" layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { replacequery } from "@/api/plant";
export default {
  mounted() {
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //搜索表单数据
      searchform: {
        orderno: "",
        batchno: "",
        qrcode: "",
        boxCode: "",
        datelist: [],
        create_start_time: "",
        create_end_time: "",
        pageIndex: 1,
        pageSize: 20
      }
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      replacequery(obj).then(response => {
        this.tableData = response.data.data;
        this.packdate(this.tableData)
        this.currentPage = response.data.page_index;
        this.total_count = response.data.total_count;
        this.listLoading = false;
      });
    },
    packdate(obj) {
      for (let i = 0; i < obj.length; i++) {
        console.log(obj[i].collection_time)
        obj[i].collection_time = this.$parseTime(Number(obj[i].collection_time));
        obj[i].create_time = obj[i].create_time.replace(/T/, " ");
        obj[i].period_date = (obj[i].period_date.replace(/T/, " ")).substring(0, obj[i].period_date.replace(/T/, " ").length - 8);
        switch (obj[i].package_level_parent) {
          case '0': obj[i].package_level_parent = ' '
            break;
          case '1': obj[i].package_level_parent = '一级包装'
            break;
          case '2': obj[i].package_level_parent = '二级包装'
            break;
          default: obj[i].package_level_parent = ''; obj[i].qrcode_parent = '';
            break;
        }
        switch (obj[i].qrcode_level) {
          case 0: obj[i].qrcode_level = ' '
            break;
          case 1: obj[i].qrcode_level = '一级包装'
            break;
          case 2: obj[i].qrcode_level = '二级包装';
            break;
          default:
            break;
        }
      }
    },
    //搜索事件
    search() {
      this.Tabledata({
        orderno: this.searchform.orderno,
        batchno: this.searchform.batchno,
        qrcode: this.searchform.qrcode,
        create_start_time: this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time: this.searchform.datelist == null ? null : this.searchform.datelist[1],
        pageSize: this.searchform.pageSize
      });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(pageIndex) {
      this.searchform.pageIndex = pageIndex
      this.Tabledata({
        orderno: this.searchform.orderno,
        batchno: this.searchform.batchno,
        qrcode: this.searchform.qrcode,
        create_start_time: this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time: this.searchform.datelist == null ? null : this.searchform.datelist[1],
        pageIndex: this.searchform.pageIndex,
        pageSize: this.searchform.pageSize
      });
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize
      this.search()
    },
    //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
        orderno: this.searchform.orderno,
        batchno: this.searchform.batchno,
        qrcode: this.searchform.qrcode,
        create_start_time: this.searchform.datelist == null ? null : this.searchform.datelist[0],
        create_end_time: this.searchform.datelist == null ? null : this.searchform.datelist[1],
      };
      replacequery(obj).then(response => {
        this.packdate(response.data.data)
        this.tableDataDownload = response.data.data;

        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "编号",
            "旧码",
            "新码",
            "包装级别",
            "父级码",
            "父级包装级别",
            "订单",
            "生产批次",
            "保质期",
            "采集时间",
            "关联替换时间",
            "备注"
          ];
          const filterVal = [
            "id",
            "qrcode_old",
            "qrcode_new",
            "qrcode_level",
            "qrcode_parent",
            "package_level_parent",
            "orderno",
            "batchno",
            "period_date",
            "collection_time",
            "create_time",
            "create_user"

          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped></style>
